import React from 'react';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { SpriteSvg } from '@/components/common/SpriteSvg';
import { useLoading } from '@/providers/LoadingProvider';
import { ModalAgeVerification } from '@/components/common/Modal/ModalAgeVerification';

type Props = {
  type?: 'top' | 'creator';
  children?: React.ReactNode;
};

export const AppLayout = (props: Props) => {
  const { showLoading } = useLoading();

  return (
    <>
      <Header type={props.type} />
      <main>
        {props.children}
        {showLoading && (
          <div className={`loading active`}>
            <SpriteSvg name={'icon-loading'} className={'i'} />
          </div>
        )}
        <ModalAgeVerification />
      </main>
      <Footer />
    </>
  );
};
